module.exports = __webpack_public_path__ + "img/announcement.73f377ed.svg";